<template>
  <div class="services">
    <page-header title="Услуги" />
    <div class="public-container public-container-mobile">
      <public-service-links-grid
        id="main"
        :title="content.blocks?.main.title"
        :items="mainItems"
        title-icon-url="/svg/box-transportation.svg"
        text-only
        class="mt-70"
      />
      <public-service-links-grid
        id="transportation"
        :title="content.blocks?.transportation.title"
        :items="transportationItems"
        title-icon-url="/svg/car/truck.svg"
        text-only
        class="mt-110"
      />
      <public-service-links-grid
        id="services"
        :title="content.blocks?.services.title"
        :items="servicesItems"
        title-icon-url="/svg/vz-gear.svg"
        text-only
        class="mt-110 mb-110"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import PageHeader from '~/components/public/page-header.vue'
import PublicServiceLinksGrid from '~/components/public/public-service-links-grid.vue'
import {getPageContent} from '~/api/content';
import useMenuItems from "~/composables/useMenuItems";

const {isHideInsurance} = useMenuItems()
const content = await getPageContent('/services')

const mainItems = computed(() => {
  const result = [
    {
      title: content.blocks?.main.addressDeliveryTitle,
      text: content.blocks?.main.addressDeliveryText,
      link: {
        to: { name: 'address-delivery' }
      }
    },
    {
      title: content.blocks?.main.wrappingTitle,
      text: content.blocks?.main.wrappingText,
      link: {
        to: { name: 'wrapping' }
      }
    },
    {
      title: content.blocks?.main.storageTitle,
      text: content.blocks?.main.storageText,
      link: {
        to: { name: 'safe-custody' }
      }
    },
    {
      title: content.blocks?.main.insuranceTitle,
      text: content.blocks?.main.insuranceText,
      link: {
        to: { name: 'insurance' }
      }
    },
    {
      title: content.blocks?.main.prrTitle,
      text: content.blocks?.main.prrText,
      link: {
        to: { name: 'cargo-loading' }
      }
    },
    {
      title: content.blocks?.main.returnSdTitle,
      text: content.blocks?.main.returnSdText,
      link: {
        to: { name: 'return-sd' }
      }
    }
  ]

  if (isHideInsurance) {
    const findInsurance = result.findIndex((val) => val.link.to.name === 'insurance')
    result.splice(findInsurance, 1)
  }

  return result
})

const transportationItems = computed(() => [
  {
    title: content.blocks?.transportation.networkTitle,
    text: content.blocks?.transportation.networkText,
    link: {
      to: { name: 'networkshops' }
    }
  },
  {
    title: content.blocks?.transportation.onlineStoreTitle,
    text: content.blocks?.transportation.onlineStoreText,
    link: {
      to: { name: 'online-store' }
    }
  },
  {
    title: content.blocks?.transportation.groupageCargoTitle,
    text: content.blocks?.transportation.groupageCargoText,
    link: {
      to: { name: 'delivery-russia' }
    }
  },
  {
    title: content.blocks?.transportation.groupPickupTitle,
    text: content.blocks?.transportation.groupPickupText,
    link: {
      to: { name: 'free-group-pickup' }
    }
  },
  {
    title: content.blocks?.transportation.pupTitle,
    text: content.blocks?.transportation.pupText,
    link: {
      to: { name: 'marketplace-yandex-market' }
    }
  },
  {
    title: content.blocks?.transportation.belarusTitle,
    text: content.blocks?.transportation.belarusText,
    link: {
      to: { name: 'belarus' }
    }
  },
  {
    title: content.blocks?.transportation.shippingtypesTitle,
    text: content.blocks?.transportation.shippingtypesText,
    link: {
      to: { name: 'shippingtypes' }
    }
  },
  {
    title: content.blocks?.transportation.fastDeliveryTitle,
    text: content.blocks?.transportation.fastDeliveryText,
    link: {
      to: { name: 'fast-delivery-capital' }
    }
  }
])

const servicesItems = computed(() => [
  {
    title: content.blocks?.services.forwardingReceiptTitle,
    text: content.blocks?.services.forwardingReceiptText,
    link: {
      to: { name: 'forwarding-receipt' }
    }
  },
  {
    title: content.blocks?.services.codTitle,
    text: content.blocks?.services.codText,
    link: {
      to: { name: 'cash-on-delivery' }
    }
  },
  {
    title: content.blocks?.services.edoTitle,
    text: content.blocks?.services.edoText,
    link: {
      to: { name: 'edo' }
    }
  }
])
</script>

<style lang="scss" scoped>
.services {
  .public-service-links-grid {
    &:first-child {
      @media screen and (max-width: $pub-sm) {
        margin-top: 50px;
      }
    }

    &:not(:first-child) {
      @media screen and (max-width: $pub-md) {
        margin-top: 90px;
      }

      @media screen and (max-width: $pub-sm) {
        margin-top: 70px;
      }
    }

    &:last-child {
      @media screen and (max-width: $pub-md) {
        margin-bottom: 90px;
      }

      @media screen and (max-width: $pub-sm) {
        margin-bottom: 70px;
      }
    }
  }
}
</style>
